import { Observable, of } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { APP_USER_VALIDATE_EMAIL_ROUTE } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class Tier2PasswordlessGuard implements CanActivate, CanActivateChild {
  constructor(@Inject(PLATFORM_ID) private platform: Object, private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (
      this.router.getCurrentNavigation().extras?.state?.passwordlessTier2 === 'true' ||
      this.router.getCurrentNavigation().extras?.queryParams?.passwordless === 'true'
    ) {
      return of(true);
    }

    return of(this.router.createUrlTree([APP_USER_VALIDATE_EMAIL_ROUTE]));
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
